module.exports = {"id":"164468","name":"Gary Cahill","rating":"82","photo":"./data/images/photos/4/164468.png","club":{"name":"Chelsea","logo":"./data/images/clubs/Chelsea.png"},"positions":["DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GaryCahill0.json
// module id = 1534
// module chunks = 0